module.exports = __webpack_public_path__ + "img/logo_creame.8a4adf5.png";